export default __webpack_public_path__ + "static/media/Nurutdinov_Airat_Rafkatovich.2d972f32.webp";